import { render } from "./InvoiceDetails.vue?vue&type=template&id=5c81284e"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__